import { getSubmeters } from '@/services/eos/submeters'
import type { ISubmeterFilters } from '@/types/eos/filters'
import { useQuery } from '@tanstack/vue-query'

export const useSubmeters = () => {
  const getSubmetersQuery = (filters: ISubmeterFilters) =>
    useQuery({
      queryKey: ['submeters', filters],
      queryFn: () => getSubmeters(filters),
    })

  return {
    getSubmetersQuery,
  }
}
